import heroImage from "../assets/images/hero-healthcare-team.jpg";
import { Link } from "react-router-dom";



function Hero() {
  return (
    <section className="hero-section" id="home">
      <div className="hero-copy">
        <h1>
          Healthcare Staffing
          <br />
          You Can Trust
        </h1>

        <p>
          Connecting exceptional healthcare professionals with exceptional
          care across Ontario and Canada.
        </p>

        <div className="hero-buttons">
          <Link
             className="primary-button"
              to="/facility/register"
          >
              Find Staff
        </Link>

        <a
         className="secondary-button"
         href="/#assignments"
      >
             Find Assignments
       </a>
         </div>
      </div>

      <div className="hero-image-wrapper">
        <img
          src={heroImage}
          alt="Healthcare professionals working together"
          className="hero-image"
        />
      </div>
    </section>
  );
}

export default Hero;